import { Tooltip, Button, Box, Divider } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import IdentidadEjemplo from '../../participante/IdentidadEjemplo.jpg'
import { useMediaQuery } from '@mui/material';
import * as React from 'react';

export default function Aval({ selectedIdentidadAval1, setselectedIdentidadAval1, selectedVoucherIdentidadAval1, setselectedVoucherIdentidadAval1 }) {
    const isMobile = useMediaQuery('(max-width:820px)'); // Detectar si es una pantalla móvil

    //-------Identidad--------------------------
    const handleFileChangeIdentidadSoli = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'application/pdf') {
            setselectedIdentidadAval1(file);
        } else {
            alert('Por favor seleccione un archivo con formato PDF.');
        }
    };

    const handleDragOverIdentidadSoli = (event) => {
        event.preventDefault();
    };

    const handleClickIdentidadSoli = () => {
        document.getElementById('selectedIdentidadAval1').click();
    };

    const handleDropIdentidadSoli = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type === 'application/pdf') {
            setselectedIdentidadAval1(file);
        } else {
            alert('Por favor suelta un archivo con formato PDF.');
        }
    };

    //-----VOUCHER-----------------
    const handleFileChangeVoucher = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'application/pdf') {
            setselectedVoucherIdentidadAval1(file);
        } else {
            alert('Por favor seleccione un archivo con formato PDF.');
        }
    };

    const handleDragOverVoucher = (event) => {
        event.preventDefault();
    };

    const handleClickVoucher = () => {
        document.getElementById('selectedVoucherIdentidadAval1').click();
    };

    const handleDropVoucher = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type === 'application/pdf') {
            setselectedVoucherIdentidadAval1(file);
        } else {
            alert('Por favor suelta un archivo con formato PDF.');
        }
    };
    return (
        <>

            <Box marginTop={5}>
                {<h3>IV. COPIA DE LA IDENTIDAD EN FORMATO PDF DEL AVAL 1</h3>}
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    onDragOver={handleDragOverIdentidadSoli}
                    onDrop={handleDropIdentidadSoli}
                >
                    <Box
                        style={{
                            padding: '50px',
                            width: isMobile ? '300px' : '700px',
                            textAlign: 'center',
                            borderColor: selectedIdentidadAval1 ? 'green' : 'var(--color-gray-500)',
                            borderRadius: 5,
                            borderWidth: 5,
                            borderStyle: 'dashed',
                        }}
                    >
                        <Tooltip
                            title={
                                <div style={{ textAlign: 'center' }}>
                                    <p style={{ fontSize: 15, textAlign: 'justify' }}>El archivo pdf debe contener la tarjeta de identidad por ambos lados de la siguiente forma:</p>
                                    <img src={IdentidadEjemplo} alt="Identidad Ejemplo" style={{ width: '200px', height: 'auto' }} />
                                </div>
                            }
                            interactive
                        >
                            <CloudUploadIcon style={{ fontSize: 48, color: 'var(--color-gray-500)' }} />
                        </Tooltip>
                        <br />
                        <Button
                            variant="contained"
                            onClick={handleClickIdentidadSoli}
                            style={{ marginTop: '10px', backgroundColor: 'var(--color-surface-muted)' }}
                        >
                            Seleccionar Identidad En PDF
                        </Button>
                        <input
                            id="selectedIdentidadAval1"
                            type="file"
                            accept=".pdf"
                            style={{ display: 'none' }}
                            onChange={handleFileChangeIdentidadSoli}
                        />
                        {!selectedIdentidadAval1 && <p>Seleccione el archivo PDF o Arrástrelo dentro del contenedor</p>}
                        {selectedIdentidadAval1 && <p>Archivo seleccionado: {selectedIdentidadAval1.name}</p>}
                    </Box>
                </Box>
            </Box>

            <Box marginTop={5}>
                {<h3>V. VOUCHER DE PAGO EN FORMATO PDF DEL AVAL 1</h3>}
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    onDragOver={handleDragOverVoucher}
                    onDrop={handleDropVoucher}
                >
                    <Box
                        style={{
                            padding: '50px',
                            width: isMobile ? '300px' : '700px',
                            textAlign: 'center',
                            borderColor: selectedVoucherIdentidadAval1 ? 'green' : 'var(--color-gray-500)',
                            borderRadius: 5,
                            borderWidth: 5,
                            borderStyle: 'dashed',
                        }}
                    >

                        <CloudUploadIcon style={{ fontSize: 48, color: 'var(--color-gray-500)' }} />
                        <br />
                        <Button
                            variant="contained"
                            onClick={handleClickVoucher}
                            style={{ marginTop: '10px', backgroundColor: 'var(--color-surface-muted)' }}
                        >
                            Seleccionar Voucher En PDF
                        </Button>
                        <input
                            id="selectedVoucherIdentidadAval1"
                            type="file"
                            accept=".pdf"
                            style={{ display: 'none' }}
                            onChange={handleFileChangeVoucher}
                        />
                        {!selectedVoucherIdentidadAval1 && <p>Seleccione el archivo PDF o Arrástrelo dentro del contenedor</p>}
                        {selectedVoucherIdentidadAval1 && <p>Archivo seleccionado: {selectedVoucherIdentidadAval1.name}</p>}
                    </Box>
                </Box>
            </Box>
        </>
    );
}


